<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { get } from "lodash";
import lockIcon from "!!raw-loader!../../images/lock.svg";
import shave from "shave";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin, interactionMixin],
  props: {
    showFavouriteTrigger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bgVideoActive: false,
    };
  },
  mounted() {
    Vue.nextTick(() => {
      if (["h1", "h2", "display-1"].includes(this.content.title_class)) {
        shave($(this.$el).find(".dotdotdot-title"), 227);
      } else {
        shave($(this.$el).find(".dotdotdot-title"), 70);
      }

      shave($(this.$el).find(".dotdotdot-subtitle"), 70);
    });
  },
  methods: {
    getContentURL: Fandom.getContentURL,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTileThumbnailUrl: Fandom.getTileThumbnailUrl
  },
  computed: {
    linkLabelClasses() {
      return this.authorized ? 'text-primary' : "disabled";
    },
    lockIconClasses() {
      const colors = this.content.theme === "dark" ? "bg-white text-primary" : "bg-primary text-white";
      return [
        colors
      ];
    },
    contentUrl() {
      return this.authorized ? this.getContentURL(this.content) : false;
    },
    sideImage() {
      if (this.content.thumbnail) {
        return this.getTileThumbnailUrl();
      }
      return false;
    },
    componentTag() {
      return this.authorized ? "a" : "div";
    },
    lockIcon() {
      return lockIcon;
    },
    isCollectionTile() {
      return this.content.parent_names.includes('collection');
    },
    urlTitle() {
      const buttonTitle = get(this, ["content", "button_title"], this.ft("globals.see_content"));
      const urlTitle = get(this, ["content", "url", "title"], "");
      return urlTitle !== "" ? urlTitle : buttonTitle;
    },
    isCustomContent() {
      return this.content.button_icon_class || this.content.parent_names.includes('content-type-video');
    },
    iconClass() {
      return this.content.button_icon_class ? this.content.button_icon_class
        : this.content.parent_names.includes('content-type-video') ? 'fas fa-play ml-1 font-base' : 'far fa-chevron-right'
    }
  }
};
</script>

<template>
  <component 
    tile-ultrawide-component
    tile-component
    :class="[contentType, {'collection-tile': isCollectionTile}]"
    :is="componentTag"
    v-easyadmin="easyadminId" 
    class="position-relative d-block tile-shadow"
    :href="contentUrl"
    :target="getTarget(content.url)"
    v-if="isContentVisibleToUser()"
  >
    <div
      v-if="!authorized"
      class="position-absolute-center locked-layer w-100 h-100 cursor-pointer"
      @click.prevent="mayRedirectOnFreeContent(true)"
      >
    </div>
    <div class="d-flex flex-column flex-md-row tile__content h-100 align-items-center">
      <div class="tile__image-section">
        <div class="ar-16by9 h-100 bg-cover-center side-image position-relative" v-if="sideImage" :style="{'background-image': sideImage}">
        </div>
      </div>
      <div class="tile__text-section p-4 d-flex flex-column justify-content-between h-100 position-relative">
        <div class="position-absolute favourite-trigger d-flex align-items-center" v-if="content.favourite && showFavouriteTrigger">
          <span class="d-none d-md-inline" v-if="!isFavourite(containerContent, content.favourite.interaction)">{{ft('globals.save')}}</span>
          <span class="d-none d-md-inline" v-else>{{ft('globals.delete')}}</span>
          <i
            :class="isFavourite(containerContent, content.favourite.interaction) ? 'text-primary fas' : 'fal'"
            class="fa-bookmark ml-3 cursor-pointer fa-lg"
            @click.stop.prevent="updateFavouriteInteraction(containerContent, content.favourite, content.favourite.interaction)"
          ></i>
        </div>
        <div>
          <div
            v-if="category"
            :class="content.category_class ? content.category_class : content.theme == 'dark' ? 'white' : 'dark'"
            class="tile__category small mb-4 d-inline-block px-3 py-1"
          >
            <div class="d-flex align-items-center">
              <img v-if="categoryIcon && categoryIcon.url" :src="categoryIcon.url" class="category-icon mr-2"/> 
              <i v-else-if="categoryIcon" class="fas mr-2" :class="`fa-${categoryIcon}`"></i>
              {{category}}
            </div>
          </div>
          <p v-if="content.title" class="dotdotdot-title h4 font-weight-bold">{{content.title}}</p>
          <p v-if="content.subtitle" v-html="content.subtitle" class="dotdotdot-subtitle"></p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="d-flex align-items-center justify-content-between cursor-pointer link-label" :class="linkLabelClasses">
            <div v-if="isCustomContent" class="tile-icon-container d-flex justify-content-center align-items-center" :class="content.theme == 'dark' ? 'white' : 'primary'">
              <i :class="iconClass"></i>
            </div>
            <i v-else class="far fa-chevron-right"></i>
            <span class="ml-2">{{urlTitle}}</span>
          </span>
          <span class="d-flex align-items-center p-3 lock-icon" v-if="!authorized" :class="lockIconClasses" v-html="lockIcon">
          </span>
        </div>
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
[tile-ultrawide-component] {
  color: black;
  
  .tile__text-section {
    width: 100%;
    flex: 6;
  }

  .tile__image-section {
    align-self: stretch;
    flex: 6;
  }

  &.collection-tile .side-image {
    background-position: center -140px !important;
  }

  .favourite-trigger {
    right: 1.5rem;
    top: 1.5rem;
  }

  @include media-breakpoint-up(md) {
    .tile__text-section {
      flex: 12;
      min-height: 18rem;
    }

    .tile__image-section {
      flex: 6;
      align-self: stretch;
    }

    .side-image {
      border-top-left-radius: .5rem;
      border-bottom-left-radius: .5rem;
      border-bottom-right-radius: 0rem;
      border-top-right-radius: 0rem;
    }
  }

}
</style>
